export default class ConditionallyShownContent {
  constructor($el, options = {}) {
    this.selectors = {
      toggleContainer: options.toggleContainer || '.js-conditional-content-toggle',
      conditionallyShownContent: options.conditionallyShownContent || '.js-conditionally-shown-content',
      triggerElement: options.triggerElement || '.js-conditional-content-trigger',
    };

    this.$container = $el;
    this.$toggleContainer = this.$container.find(this.selectors.toggleContainer);
    this.$conditionallyShownContent = this.$container.find(this.selectors.conditionallyShownContent);
    this.triggerElement = this.$container.find(this.selectors.triggerElement)[0];

    this.hiddenClass = 'hide';
    this.requiredClass = 'js-required';

    this.$toggleContainer.on('change', this.updateContent.bind(this));

    setTimeout(() => {
      this.updateContent();
    }, 0);
  }

  showContent($el) {
    $el.removeClass(this.hiddenClass);

    if ($el.hasClass(this.requiredClass)) {
      $el.prop('required', true);
      $el.trigger('content-shown');
    }
  }

  hideContent($el) {
    $el.addClass(this.hiddenClass);

    if ($el.hasClass(this.requiredClass)) {
      $el.removeAttr('required');
    }
  }

  updateContent() {
    if (this.$toggleContainer.is('select')) {
      const dropdownFieldsMap = this.$toggleContainer.data('dropdownFieldsMap');
      const visibleContentClass = dropdownFieldsMap[this.$toggleContainer.val()];
      const $visibleContentField = this.$container.find(visibleContentClass);

      this.hideContent(this.$conditionallyShownContent);
      this.showContent($visibleContentField);
    } else if (this.triggerElement.checked) {
      this.showContent(this.$conditionallyShownContent);
    } else {
      this.hideContent(this.$conditionallyShownContent);
    }
  }
}
